module.exports = __webpack_public_path__ + "static/media/suite7.3e9b9ce8.png";